<template>
    <div class="col-12">
        <input type="checkbox" v-model="model" id="terms" name="terms" style="margin-right: 10px;">
        <label for="terms">
            I agree to the 
            <a :href="pdfUrl" target="_blank" class="wl-interactive" style="text-decoration: underline!important;">
                Terms & Conditions
            </a> 
            and acknowledge having read the Privacy Policy.
        </label>
    </div>
</template>

<script>
    export default {
        name: "TermsAndConditions",
        props: {
            value: {
                type: Boolean,
                required: true,
            },
            dateOption: true
        },
        data() {
            return {
                model: this.value,
                pdfUrl: `https://www.myameriflex.net/Document/Viewer/c0a7bf1aa9894d7e98dd4b80b6393f67`
            };
        },
        watch: {
            model(value) {
                this.$emit('input', value);
            }
        },
    }
</script>

<style scoped>
    input[type=checkbox] {
        transform: scale(1.5);
    }

    label {
        display: inline-block;
        vertical-align: top;
        color: #475e72;
    }

    a {
        color: #30b182;
    }
</style>